/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ApiErrorResponse,
  InstallMcpToolsetRequest,
  McpToolsetInstallResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiMcpToolsetsInstallUrl = () => {




  return `/api/mcp-toolsets/install`
}

export const postApiMcpToolsetsInstall = async (installMcpToolsetRequest: InstallMcpToolsetRequest, options?: RequestInit): Promise<McpToolsetInstallResponse> => {

  return orvalControlFetch<McpToolsetInstallResponse>(getPostApiMcpToolsetsInstallUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      installMcpToolsetRequest,)
  }
);}




export const getPostApiMcpToolsetsInstallMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMcpToolsetsInstall>>, TError,{data: InstallMcpToolsetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiMcpToolsetsInstall>>, TError,{data: InstallMcpToolsetRequest}, TContext> => {

const mutationKey = ['postApiMcpToolsetsInstall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMcpToolsetsInstall>>, {data: InstallMcpToolsetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiMcpToolsetsInstall(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiMcpToolsetsInstallMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMcpToolsetsInstall>>>
    export type PostApiMcpToolsetsInstallMutationBody = InstallMcpToolsetRequest
    export type PostApiMcpToolsetsInstallMutationError = ApiErrorResponse

    export const usePostApiMcpToolsetsInstall = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMcpToolsetsInstall>>, TError,{data: InstallMcpToolsetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiMcpToolsetsInstall>>,
        TError,
        {data: InstallMcpToolsetRequest},
        TContext
      > => {
      return useMutation(getPostApiMcpToolsetsInstallMutationOptions(options), queryClient);
    }
